import { css } from '@emotion/css'
import { borderRadius, breakpoint } from '../../styles'
import { mediaQueryHelper } from '../../styles/helpers'
import { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  card: css({
    width: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    borderBottom: `1px solid ${colors.mystic}`,
    borderTop: `1px solid ${colors.mystic}`,

    [mediaQueryHelper(breakpoint.tablet)]: {
      borderRadius: borderRadius.default,
      boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
      border: 0,
    },
  }),
}

export default styles

export const cardTheme = theme => {
  switch (theme) {
    case 'light':
      return css({
        backgroundColor: colors.athensGray,
      })

    default:
      return css({
        backgroundColor: colors.white,
      })
  }
}
